import { styled } from "styled-components";
import { Assets } from "../styles/assets";

export const TitleStyle = styled.h1`
  font-size: 40px;
  font-family: 'Inter', Arial, sans-serif;
  font-weight: bold;
  color: ${Assets.primaryColor};    
  margin-bottom: 20px;
`;

export const TitleBodyStyle = styled.h1<{ $marginbottom?: string }>`
  font-size: 24px;
  font-family: 'Inter', Arial, sans-serif;
  font-weight: 700;
  color: #fff;
  margin:0;  
`;

export const DescriptionBodyStyle = styled.p<{ $margintop?: string; $marginbottom?: string }>`
  font-size: 12px;
  font-family: 'Inter', Arial, sans-serif;
  color: #9CA3AF;
  padding:0;  
  margin:0;
  text-align: left;  
  margin-top: ${({ $margintop }) => $margintop || '5px'};
  margin-bottom: ${({ $marginbottom }) => $marginbottom || '0px'};
`;

